<div class="video-ad-container d-none" [id]="adContainerId" #adContainerElement></div>
<flo-video-error
  class="video-ad-container d-none justify-content-center align-items-center flex-column position-absolute top left right bottom"
  title="Commercial Break"
>
  <p *ngIf="adTimer$ | async as adTimer"
    >Your event will resume in {{ adTimer | floTime }}</p
  >
</flo-video-error>
